import { useWindowDimensions } from './useWindowDimensions'

interface IProps {
  mobile: {
    enterAnimation: any
    leaveAnimation: any
  }
  desktop: {
    enterAnimation: any
    leaveAnimation: any
  }
}

export const useMobileModalAnimationSwitcher = ({ mobile, desktop }: IProps) => {
  const { isMobile } = useWindowDimensions()

  return isMobile ? mobile : desktop
}
